import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config/api';
import { authFetch } from '../utils/authFetch';
import { Transaction, PaginatedResponse } from '../types/plaid';

const fetchTransactions = async (page: number = 1): Promise<PaginatedResponse<Transaction>> => {
  const response = await authFetch(
    `${API_URL}/integrations/plaid/transactions?page=${page}`
  );
  if (!response.ok) {
    throw new Error('Failed to fetch transactions');
  }
  return response.json();
};

export const useListTransactions = (page: number = 1) => {
  return useQuery<PaginatedResponse<Transaction>>({
    queryKey: ['transactions', page],
    queryFn: () => fetchTransactions(page),
    placeholderData: (previousData) => previousData, // Keep previous data while fetching new page
  });
}; 